<template>
    <section class="wizards">
        <section class="empty"></section>
        <section class="wraper">
            <eSesjaLogo />
            <router-view />
        </section>
        <eSesjaFooter />
    </section>
</template>
<script charset="utf-8">
    // components
    import eSesjaFooter from "../components/Shared/eSesjaFooter.vue"
    import eSesjaLogo from "../components/Shared/eSesjaLogo.vue"

    export default {
        name: "Wizards",
        components: {
            eSesjaFooter,
            eSesjaLogo
        }
    }
</script>
<style lang="scss">
    .wizards {
        background: radial-gradient(235.38% 418.45% at 0% 0%, #00082c 0%, #004dcc 100%);
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        .wraper {
            display: flex;
            flex-direction: column;
            row-gap: 20px;
        }
    }
</style>